export default __webpack_public_path__ + "static/media/edsysLogo.26c6d853.svg";